(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/store/pd-preferences-slice.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/store/pd-preferences-slice.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const {
  FULFILLED,
  REJECTED
} = svs.myProfile.constants.thunkStatus;
const {
  logger
} = svs.myProfile;
const {
  getCustomizedsettingsAsync,
  postEmailAsync,
  postCellPhoneAsync,
  deleteCellPhoneAsync,
  postAliasAsync
} = svs.myProfile.react.pages.myInformation.myInformationService;
const getCustomersPreferences = RTK.createAsyncThunk('playerdetails/getpreferences', async (_, _ref) => {
  let {
    rejectWithValue,
    getState
  } = _ref;
  const playerCustomizedSettingsStatus = getState().playerCustomizedSettings.playerCustomizedSettingsStatus.status;
  const existingplayerCustomizedSettings = getState().playerCustomizedSettings.playerCustomizedSettings;
  if (!svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
    return rejectWithValue({
      error: null
    });
  }
  if (playerCustomizedSettingsStatus !== 'initial' && existingplayerCustomizedSettings.customerId) {
    return existingplayerCustomizedSettings;
  }
  try {
    const {
      playerCustomizedSettings,
      error
    } = await getCustomizedsettingsAsync();
    if (error) {
      logger.warn('Error in get preferences...', error);
      return rejectWithValue({
        error
      });
    }
    return playerCustomizedSettings;
  } catch (error) {
    logger.warn('Error in get preferences...', error);
    return rejectWithValue({
      error
    });
  }
});
const saveEmail = RTK.createAsyncThunk('playerdetails/saveemail', async (email, _ref2) => {
  let {
    rejectWithValue
  } = _ref2;
  try {
    var _svs$accountservices;
    const {
      error
    } = await postEmailAsync(email);
    if (error !== null) {
      logger.debug('Error in post save email...', error);
      return rejectWithValue({
        error: error.code
      });
    }
    (_svs$accountservices = svs.accountservices) === null || _svs$accountservices === void 0 || (_svs$accountservices = _svs$accountservices.player_notifications_checker) === null || _svs$accountservices === void 0 || (_svs$accountservices = _svs$accountservices.events) === null || _svs$accountservices === void 0 || _svs$accountservices.trigger('clear');
    return {
      error: null,
      email
    };
  } catch (error) {
    logger.debug('Error in post confirm email catch...', error);
    return rejectWithValue({
      error
    });
  }
});
const saveCellPhone = RTK.createAsyncThunk('playerdetails/savemobile', async (mobile, _ref3) => {
  let {
    rejectWithValue
  } = _ref3;
  try {
    var _svs$accountservices2;
    const {
      error
    } = await postCellPhoneAsync(mobile);
    if (error !== null) {
      logger.debug('Error in post save mobile...', error);
      return rejectWithValue({
        error: error.code
      });
    }
    (_svs$accountservices2 = svs.accountservices) === null || _svs$accountservices2 === void 0 || (_svs$accountservices2 = _svs$accountservices2.player_notifications_checker) === null || _svs$accountservices2 === void 0 || (_svs$accountservices2 = _svs$accountservices2.events) === null || _svs$accountservices2 === void 0 || _svs$accountservices2.trigger('clear');
    return {
      error: null,
      mobile
    };
  } catch (error) {
    logger.warn('Error in post save mobile catch...', error);
    return rejectWithValue({
      error
    });
  }
});
const deleteCellPhone = RTK.createAsyncThunk('playerdetails/deletemobile', async (cellPhone, _ref4) => {
  let {
    rejectWithValue
  } = _ref4;
  try {
    var _svs$accountservices3;
    const {
      error
    } = await deleteCellPhoneAsync(cellPhone);
    if (error !== null) {
      logger.warn('Error in delete cellPhone', error);
      return rejectWithValue({
        error: error.code
      });
    }
    (_svs$accountservices3 = svs.accountservices) === null || _svs$accountservices3 === void 0 || (_svs$accountservices3 = _svs$accountservices3.player_notifications_checker) === null || _svs$accountservices3 === void 0 || (_svs$accountservices3 = _svs$accountservices3.events) === null || _svs$accountservices3 === void 0 || _svs$accountservices3.trigger('clear');
    return {
      error: null
    };
  } catch (error) {
    logger.warn('Error in delete cellPhone catch...', error);
    return rejectWithValue({
      error
    });
  }
});
const saveAlias = RTK.createAsyncThunk('playerdetails/savealias', async (alias, _ref5) => {
  let {
    rejectWithValue
  } = _ref5;
  try {
    var _svs$accountservices4;
    const {
      error,
      aliasAccepted,
      suggestedAlias
    } = await postAliasAsync(alias);
    if (error !== null) {
      logger.debug('Error in post save alias...', error);
      return rejectWithValue({
        error: error.code
      });
    }
    if (!aliasAccepted) {
      logger.debug('Error in post save alias...', error);
      return rejectWithValue({
        error: 'taken',
        suggestedAlias
      });
    }
    (_svs$accountservices4 = svs.accountservices) === null || _svs$accountservices4 === void 0 || (_svs$accountservices4 = _svs$accountservices4.player_notifications_checker) === null || _svs$accountservices4 === void 0 || (_svs$accountservices4 = _svs$accountservices4.events) === null || _svs$accountservices4 === void 0 || _svs$accountservices4.trigger('clear');
    return {
      error: null,
      alias
    };
  } catch (error) {
    logger.debug('Error in post alias catch...', error);
    return rejectWithValue({
      error
    });
  }
});
const pdPrefSlice = RTK.createSlice({
  name: 'pdpreferences',
  initialState: {
    playerCustomizedSettings: {},
    playerCustomizedSettingsStatus: {
      status: 'initial'
    },
    isPreferenceDataLoaded: false,
    isForceSaveMobile: false,
    isForceSaveEmail: false,
    isForceSaveAlias: false
  },
  reducers: {
    setForceSaveEmail: (state, action) => {
      state.isForceSaveEmail = action.payload;
    },
    setForceSaveMobile: (state, action) => {
      state.isForceSaveMobile = action.payload;
    },
    setForceSaveAlias: (state, action) => {
      state.isForceSaveAlias = action.payload;
    },
    setVerifyEmail: state => {
      state.playerCustomizedSettings = _objectSpread(_objectSpread({}, state.playerCustomizedSettings), {
        emailStatus: '2'
      });
    }
  },
  extraReducers(builder) {
    builder.addCase(saveEmail.fulfilled, (state, action) => {
      state.playerCustomizedSettings = _objectSpread(_objectSpread({}, state.playerCustomizedSettings), {
        email: action.payload.email,
        emailStatus: '3'
      });
    }).addCase(saveCellPhone.fulfilled, (state, action) => {
      state.playerCustomizedSettings = _objectSpread(_objectSpread({}, state.playerCustomizedSettings), {
        mobile: action.payload.mobile,
        mobileStatus: '3'
      });
    }).addCase(deleteCellPhone.fulfilled, state => {
      state.playerCustomizedSettings = _objectSpread(_objectSpread({}, state.playerCustomizedSettings), {
        mobile: null,
        mobileStatus: '0'
      });
    }).addCase(getCustomersPreferences.rejected, state => {
      state.playerCustomizedSettings = {};
      state.playerCustomizedSettingsStatus = {
        status: REJECTED,
        error: 'rejected'
      };
    }).addCase(getCustomersPreferences.fulfilled, (state, action) => {
      state.playerCustomizedSettings = action.payload;
      state.playerCustomizedSettingsStatus = {
        status: FULFILLED,
        error: null
      };
      state.isPreferenceDataLoaded = true;
    }).addCase(saveAlias.fulfilled, (state, action) => {
      state.playerCustomizedSettings = _objectSpread(_objectSpread({}, state.playerCustomizedSettings), {
        alias: action.payload.alias
      });
    });
  }
});
svs.myProfile.react.store.pdPreferences.actions = _objectSpread({
  getCustomersPreferences,
  saveEmail,
  saveCellPhone,
  deleteCellPhone,
  saveAlias
}, pdPrefSlice.actions);
svs.myProfile.react.store.pdPreferences.reducer = pdPrefSlice.reducer;

 })(window);